import './MailsDecor.css';
import mailsDecorImg from './mails_decor.png';

const TILES = [0, 1, 2] as const;

/** Decorative mail strip at the bottom of welcome_delivery_2. */
export function MailsDecor() {
  return (
    <div className="welcome-mails-decor" aria-hidden>
      <div className="welcome-mails-decor__track">
        {TILES.map((index) => (
          <img
            key={index}
            className="welcome-mails-decor__img"
            src={mailsDecorImg}
            alt=""
            draggable={false}
          />
        ))}
      </div>
    </div>
  );
}
